import { routeData } from "@/router/constants/routes";

export async function serviceLocationBeforeEnter(to, from) {
    return {
        name: routeData.SCHEDULE.name,
        replace: true,
    };
}
